import Skeleton from 'style-guide/Skeleton';
import Text from 'style-guide/Typography/Text';
import Title from 'style-guide/Typography/Title';

export const CreateSurveySkeleton = () => (
  <>
    <div className='d-flex'>
      <Skeleton skeleton={{ height: 36, width: 100 }} />
      <div className='flex-1 ml--16'>
        <Skeleton skeleton={{ height: 36 }} />
      </div>
    </div>
    <div className='d-flex mv--16'>
      <Skeleton skeleton={{ height: 36, width: 100 }} />
      <div className='ml--16'>
        <Skeleton skeleton={{ height: 36, width: 100 }} />
      </div>
      <div className='flex-1 ml--16'>
        <Skeleton skeleton={{ height: 36 }} />
      </div>
    </div>
    <div className='d-flex'>
      <Skeleton skeleton={{ height: 36, width: 100 }} />
      <div className='ml--16'>
        <Skeleton skeleton={{ height: 36, width: 100 }} />
      </div>
      <div className='flex-1 ml--16'>
        <Skeleton skeleton={{ height: 36 }} />
      </div>
    </div>
  </>
);

export const SurveyViewSkeleton = () => (
  <>
    <div className='d-flex mb--16'>
      <Title variant={5} className='mr--8'>
        Type :
      </Title>
      <Text variant={5} className='mr--8'>
        <Skeleton skeleton={{ height: 24, width: 100 }} />
      </Text>
    </div>
    <div className='mb--16'>
      <Skeleton skeleton={{ height: 24 }} />
    </div>
    <Skeleton skeleton={{ height: 24 }} />
  </>
);
